import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { DashCounters } from '@apps/auth/domain/models/back/dash-counters';
import { Entity } from '@apps/auth/domain/models/back/entity';

export const BackAuthCountersRequested = createAction(
    '[BACK-AUTH-COUNTERS] Back Auth Counters Requested'
);

export const BackAuthCountersLoaded = createAction(
    '[BACK-AUTH-COUNTERS] Back Auth Counters Loaded',
    props<{ entitiesCounters: DashCounters, usersCounters: DashCounters }>()
);

// #region OData: Liste des entités externes
export const BackAuthEntitiesExternalODataRequested = createAction(
    '[BACK-AUTH-ENTITIES] Back Auth Entities External OData Requested'
);

export const BackAuthEntitiesExternalODataLoaded = createAction(
    '[BACK-AUTH-ENTITIES] Back Auth Entities External OData Loaded',
    props<{ entities: Entity[] }>()
);
export const BackAuthEntitiesExternalQsWordSet = createAction(
    '[BACK-AUTH-ENTITIES] Back Auth Entities External QsWord Set',
    props<{ qsWord: string }>()
);
export const BackAuthEntitiesExternalQsWordImpeSet = createAction(
    '[BACK-AUTH-ENTITIES] Back Auth Entities External QsWord Impe Set',
    props<{ qsWordImpe: string }>()
);
// #endregion

export const BackAuthEntityExternalUpdated = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity External Updated',
    props<{ entity: Update<Entity> }>()
);
export const BackAuthEntityAddEntityRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Add Entity Requested',
    props<{entityName: string, entityShortId: string}>()
);
export const BackAuthEntityAddEntitySucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Add Entity Succeeded',
    props<Entity>()
);
export const BackAuthEntityAddEntityFailed = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Add Entity Failed',
    props<any>()
);
